import axios from "axios";

// ==========================================
// FOOD / PUBLIC BASE
// ==========================================

const BASE_URL =
  process.env.REACT_APP_BASE_URL;

const BASE_UUID =
  process.env.REACT_APP_BASE_UUID;

const BASE_TOKEN =
  process.env.REACT_APP_BASE_TOKEN;

// ==========================================
// SQL QUERY
// ==========================================

export async function seaTableSQL(sql) {

  try {

    const response = await axios.post(

      `${BASE_URL}/${BASE_UUID}/sql/`,

      {
        sql,
        convert_keys: true
      },

      {
        headers: {

          Authorization:
            `Token ${BASE_TOKEN}`,

          Accept:
            "application/json",

          "Content-Type":
            "application/json"
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error executing SQL:",
      error.response?.data || error
    );

    throw error;
  }
}

// ==========================================
// GET TABLE
// ==========================================

export async function getTable(table) {

  try {

    const response = await axios.get(

      `${BASE_URL}/${BASE_UUID}/rows/?table_name=${table}`,

      {
        headers: {

          Authorization:
            `Token ${BASE_TOKEN}`,

          "Content-Type":
            "application/json"
        }
      }
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error fetching table:",
      error.response?.data || error
    );

    throw error;
  }
}